import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "field text-center" }
const _hoisted_3 = { class: "field text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.show,
    closable: false,
    title: _ctx.t('content.accountNotConfirmed.title')
  }, {
    beforeHeader: _withCtx(() => [
      _createElementVNode("img", {
        src: _ctx.getLogoByLocale,
        alt: "RiUM",
        style: {"width":"230px"}
      }, null, 8, _hoisted_1)
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", null, _toDisplayString(_ctx.t("content.accountNotConfirmed.body")), 1),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Button, {
            label: _ctx.t('header.signOutTitle'),
            class: "minWidth",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onClickLogout()))
          }, null, 8, ["label"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible", "title"]))
}